"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import { FaChevronRight } from "react-icons/fa";
import GradientButton from "@/components/ui/GradientButton";
import { shopifyAdvantages, ShopifyAdvantage } from "./shopify.data";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
interface ShopifyAdvantagesProps {
  heading?: string;
  subtitle?: string;
  advantages?: ShopifyAdvantage[];
  buttonText?: string;
  buttonHref?: string;
  className?: string;
}
export default function ShopifyAdvantages(t0) {
  const $ = _c(37);
  const {
    heading: t1,
    subtitle: t2,
    advantages: t3,
    buttonText: t4,
    buttonHref: t5,
    className: t6
  } = t0;
  const heading = t1 === undefined ? "Advantages of The Dezine Shopify Developer" : t1;
  const subtitle = t2 === undefined ? "Shopify offers a variety of built-in features to make the most engaging eCommerce stores. Hire the best Shopify developers from The Dezine to help you get the maximum out of Shopify solutions." : t2;
  const advantages = t3 === undefined ? shopifyAdvantages : t3;
  const buttonText = t4 === undefined ? "Hire Shopify Developer" : t4;
  const buttonHref = t5 === undefined ? "/contact" : t5;
  const className = t6 === undefined ? "" : t6;
  const desktopAnimations = useDesktopAnimations();
  const t7 = `relative overflow-hidden bg-white py-16 font-sans transition-colors duration-300 sm:py-20 lg:py-24 dark:bg-[#070b14] ${className}`;
  let t8;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="pointer-events-none absolute inset-0 opacity-40 bg-[radial-gradient(circle,rgba(75,88,125,.18)_0.8px,transparent_0.9px)] bg-[length:12px_12px]" aria-hidden="true" />;
    $[0] = t8;
  } else {
    t8 = $[0];
  }
  let t9;
  if ($[1] !== desktopAnimations) {
    t9 = desktopAnimations ? {
      opacity: 0,
      y: 30
    } : false;
    $[1] = desktopAnimations;
    $[2] = t9;
  } else {
    t9 = $[2];
  }
  let t10;
  if ($[3] !== desktopAnimations) {
    t10 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[3] = desktopAnimations;
    $[4] = t10;
  } else {
    t10 = $[4];
  }
  let t11;
  if ($[5] !== desktopAnimations) {
    t11 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[5] = desktopAnimations;
    $[6] = t11;
  } else {
    t11 = $[6];
  }
  let t12;
  let t13;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      once: true
    };
    t13 = {
      duration: 0.7,
      ease
    };
    $[7] = t12;
    $[8] = t13;
  } else {
    t12 = $[7];
    t13 = $[8];
  }
  let t14;
  if ($[9] !== heading) {
    t14 = <h2 className="font-poppins text-[30px] font-bold leading-tight text-[#0b1354] sm:text-[38px] lg:text-[44px] dark:text-white">{heading}</h2>;
    $[9] = heading;
    $[10] = t14;
  } else {
    t14 = $[10];
  }
  let t15;
  if ($[11] !== subtitle) {
    t15 = subtitle && <p className="font-sans mt-3 text-[14.5px] font-normal leading-[26px] text-[#66698a] sm:text-[16px] dark:text-gray-400">{subtitle}</p>;
    $[11] = subtitle;
    $[12] = t15;
  } else {
    t15 = $[12];
  }
  let t16;
  if ($[13] !== t10 || $[14] !== t11 || $[15] !== t14 || $[16] !== t15 || $[17] !== t9) {
    t16 = <motion.div initial={t9} whileInView={t10} animate={t11} viewport={t12} transition={t13} className="mx-auto mb-12 max-w-3xl text-center md:mb-16">{t14}{t15}</motion.div>;
    $[13] = t10;
    $[14] = t11;
    $[15] = t14;
    $[16] = t15;
    $[17] = t9;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] !== advantages || $[20] !== desktopAnimations) {
    let t18;
    if ($[22] !== desktopAnimations) {
      t18 = (item, idx) => <motion.div key={item.id} initial={desktopAnimations ? {
        opacity: 0,
        y: 35
      } : false} whileInView={desktopAnimations ? {
        opacity: 1,
        y: 0
      } : undefined} animate={desktopAnimations ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: idx % 3 * 0.12,
        ease
      }} className="h-full"><article className="group relative flex h-full flex-col justify-start overflow-hidden rounded-[20px] border border-[#e5f0f9] bg-white p-7 shadow-[0_4px_24px_rgba(20,50,90,0.05)] transition-transform duration-[1200ms] ease-[cubic-bezier(0.17,0.85,0.438,0.99)] hover:-translate-y-[7.5px] hover:shadow-[0_16px_40px_rgba(20,50,90,0.1)] sm:p-8 md:p-9 dark:border-gray-800 dark:bg-gray-900"><div className="mb-6 h-14 w-14 sm:h-16 sm:w-16"><Image src={item.icon} alt={item.alt} width={64} height={64} loading="lazy" className="h-full w-full object-contain transition-transform duration-300 group-hover:scale-105" /></div><h3 className="font-poppins mb-3 text-[20px] font-bold leading-tight text-[#0b1354] sm:text-[22px] dark:text-white">{item.title}</h3><p className="font-sans text-[14.5px] leading-[26px] text-[#5e6282] sm:text-[15.5px] dark:text-gray-400">{item.description}</p><span className="absolute inset-x-0 bottom-0 h-1 origin-left scale-x-0 bg-[linear-gradient(135deg,#9100ff_0%,#3663ff_54%,#00e2ff_100%)] transition-transform duration-[1200ms] ease-[cubic-bezier(0.17,0.85,0.438,0.99)] group-hover:scale-x-100 rounded-b-[20px]" /></article></motion.div>;
      $[22] = desktopAnimations;
      $[23] = t18;
    } else {
      t18 = $[23];
    }
    t17 = advantages.map(t18);
    $[19] = advantages;
    $[20] = desktopAnimations;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[24] !== t17) {
    t18 = <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">{t17}</div>;
    $[24] = t17;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  let t19;
  if ($[26] !== buttonHref || $[27] !== buttonText || $[28] !== desktopAnimations) {
    t19 = buttonText && <motion.div initial={desktopAnimations ? {
      opacity: 0,
      y: 24
    } : false} whileInView={desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined} animate={desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.7,
      delay: 0.25,
      ease
    }} className="mt-14 flex justify-center text-center md:mt-18"><GradientButton href={buttonHref} variant="pink-purple" className=""><span>{buttonText}</span><FaChevronRight className="ml-1 text-[12px]" /></GradientButton></motion.div>;
    $[26] = buttonHref;
    $[27] = buttonText;
    $[28] = desktopAnimations;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] !== t16 || $[31] !== t18 || $[32] !== t19) {
    t20 = <div className="relative z-10 mx-auto w-full max-w-[1280px] px-4 sm:px-6 lg:px-8">{t16}{t18}{t19}</div>;
    $[30] = t16;
    $[31] = t18;
    $[32] = t19;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== t20 || $[35] !== t7) {
    t21 = <section className={t7}>{t8}{t20}</section>;
    $[34] = t20;
    $[35] = t7;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  return t21;
}